export class DropDownStringModel {
    id: string;
    value: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/entities/dropdown-string-model.ts